export const T = {
  en_GB: {
    selectFlow: "Select Flow for Followup",
    selectFlowDescription: "Choose a flow template for the followup session.",
    noFollowupFlows:
      "No flows are enabled for followup — enable 'Supported for followup' on a flow in Settings.",
    loadingContext: "Loading agreements and accounts...",
    failedToCreateFollowup: "Failed to create followup session",
    selectTitle: "Select what to follow up",
    modeAccountsShort: "Accounts",
    modeAgreementsShort: "Savings plans",
    modeClientShort: "Entire client",
    modeAccountsDescription:
      "Each selected account gets its own portfolio seeded from its current holdings and moves to the new goal on completion.",
    modeAgreementsDescription:
      "Each selected agreement gets a recurring portfolio seeded from its current lines; new recurring orders replace the agreement's content on completion. Its accounts stay where they are.",
    modeClientDescription:
      "Everything eligible is followed up together — one new goal per existing goal, so unrelated goals stay separate. A savings plan joins the goal of the accounts it pays into.",
    noAccounts: "This client has no synced accounts to follow up.",
    noAgreements: "This client has no savings agreements to follow up.",
    noItems: "This client has no agreements or synced accounts to follow up.",
    sharesGoalWith: (names: string) => `New goal with ${names}`,
    joinsGoal: (goal: string) => `Joins ${goal}`,
    mandateGoalTypeNote:
      "An account not linked to a goal starts a new goal. Its goal type decides whether the carried mandate is checked — set it on the goal page.",
    multiPortfolioHint:
      "This flow does not support multiple portfolios — select at most one item per new goal, or choose a flow with multi-portfolio enabled.",
    multiGoalHint:
      "This flow allows only one goal, but the selection spans several goals — narrow the selection, or choose a flow with multiple goals enabled.",
    maxGoalsHint: (max: number) =>
      `This flow allows at most ${max} goals, but the selection spans more. Select fewer items (accounts or agreements mode), or choose a flow with a higher goal limit.`,
    createsGoals: (count: number) => `Creates ${count} goal(s):`,
    blockedTitle: "Followup not available",
    blockedNoCollection: "The selected flow has no portfolio collection.",
    blockedNotSupported: "The selected flow is not enabled for followup.",
    back: "Back",
    cancel: "Cancel",
    create: "Create followup",
    createCount: (count: number) => `Create followup (${count})`,
  },
  nb_NO: {
    selectFlow: "Velg flyt for oppfølging",
    selectFlowDescription: "Velg en flytmal for oppfølgingsøkten.",
    noFollowupFlows:
      "Ingen flyter er aktivert for oppfølging — aktiver 'Støttet for oppfølging' på en flyt i Innstillinger.",
    loadingContext: "Laster avtaler og kontoer...",
    failedToCreateFollowup: "Kunne ikke opprette oppfølgingsøkt",
    selectTitle: "Velg hva som skal følges opp",
    modeAccountsShort: "Kontoer",
    modeAgreementsShort: "Spareavtaler",
    modeClientShort: "Hele kunden",
    modeAccountsDescription:
      "Hver valgt konto får sin egen portefølje basert på dagens beholdning, og flyttes til det nye målet ved fullføring.",
    modeAgreementsDescription:
      "Hver valgt avtale får en spareavtaleportefølje basert på dagens linjer; nye faste ordrer erstatter avtalens innhold ved fullføring. Kontoene blir værende.",
    modeClientDescription:
      "Alt som er kvalifisert følges opp samlet — ett nytt mål per eksisterende mål, så urelaterte mål holdes adskilt. En spareavtale havner i samme mål som kontoene den sparer til.",
    noAccounts: "Denne kunden har ingen synkroniserte kontoer å følge opp.",
    noAgreements: "Denne kunden har ingen spareavtaler å følge opp.",
    noItems: "Denne kunden har ingen avtaler eller synkroniserte kontoer å følge opp.",
    sharesGoalWith: (names: string) => `Nytt mål med ${names}`,
    joinsGoal: (goal: string) => `Blir med i ${goal}`,
    mandateGoalTypeNote:
      "En konto som ikke er knyttet til et mål starter et nytt mål. Måltypen avgjør om det medfølgende mandatet kontrolleres — sett den på målsiden.",
    multiPortfolioHint:
      "Denne flyten støtter ikke flere porteføljer — velg maks ett element per nytt mål, eller velg en flyt med flerportefølje aktivert.",
    multiGoalHint:
      "Denne flyten tillater bare ett mål, men utvalget spenner over flere mål — begrens utvalget, eller velg en flyt med flere mål aktivert.",
    maxGoalsHint: (max: number) =>
      `Denne flyten tillater maks ${max} mål, men utvalget spenner over flere. Velg færre elementer (konto- eller avtalemodus), eller velg en flyt med høyere målgrense.`,
    createsGoals: (count: number) => `Oppretter ${count} mål:`,
    blockedTitle: "Oppfølging ikke tilgjengelig",
    blockedNoCollection: "Den valgte flyten har ingen porteføljesamling.",
    blockedNotSupported: "Den valgte flyten er ikke aktivert for oppfølging.",
    back: "Tilbake",
    cancel: "Avbryt",
    create: "Opprett oppfølging",
    createCount: (count: number) => `Opprett oppfølging (${count})`,
  },
} as const;
